import { exitMaintenance } from '../../../../actions/maintenanceActions';

export default function ImagingDeviceHandler(store, status){
  switch(status.ImagingDeviceService){
    case 'HEALTHY':

      break;

    case 'FATAL':
    case 'UNKNOWN':
      //Prevent take picture trigger
      if(store.getState().maintenance.active)
        store.dispatch(exitMaintenance())
      break;

    default:
      console.error('STATUS NOT REGISTERED')
  }
}